import React, { useState, useEffect } from "react";
import { Button } from 'react-bootstrap';
import _isEmpty from "lodash/isEmpty";
import _find from "lodash/find";
import _groupBy from "lodash/groupBy";
import _map from "lodash/map";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Tooltip, Checkbox } from 'antd';
import { connect } from "react-redux";
import { setFIlterSelectedItems } from '../../appRedux/actions/ExhibitorFloor';
import CustomScrollbars from '../../utils/CustomScrollbars'


function Search({
    handleCardContent = () => { },
    calculatedHeight,
    ...props
}) {

    const [tagsItems, setTagsItems] = useState([]);
    const [data, setData] = useState(false);
    const [selectedItems, setSelectedItems] = useState({});

    useEffect(() => {
        constructTags();
    }, [])

    useEffect(() => {
        setSelectedItems(props.filterSelectedItems)
    }, [props.filterSelectedItems])

    const constructTags = () => {
        let tags = [...props.tags]
        let result = tags.map(tag => {
            tag.count = (Object.keys(props.exhibitors).filter(key => props.exhibitors[key].tags.includes(tag.id)).length);
            tag['category_label'] = (_find(props.tagCategories, { catid: tag.catid })['label'] ?? '');
            return tag;
        }).filter(tag => tag.count > 0);
        setTagsItems(result);
    }

    const handleCheckBox = (key, value) => {
        let result = selectedItems;
        if (!result[key]) {
            result[key] = [];
        }
        if (result[key].includes(value)) {
            result[key] = result[key].filter(res => res !== value);
        } else {
            result[key].push(value);
        }
        if (_isEmpty(result[key])) {
            delete result[key];
        }
        props.setFIlterSelectedItems(result)
        setData(!data)
    }

    const resetFilters = () => {
        props.updateSearch({});
        props.setFIlterSelectedItems({})
    }

    return (
        <div className="exhibitor-search-body gx-p-5    ">
            <div className="exhibitor-search-header app-text-color gx-d-flex gx-justify-content-between">
                <div><h2 className='app-text-color'><b>Advanced search</b></h2></div>
                <Tooltip title="Close"><CloseCircleOutlined className="filter-close-icon-x" onClick={() => handleCardContent('exhibitor_list')} /></Tooltip>
            </div>
            <div className='gx-d-flex'>
                <button className='filter-button' onClick={() => { props.updateSearch(selectedItems) }} disabled={_isEmpty(selectedItems)}>Apply filters</button>
                <button className='filter-button' onClick={resetFilters} disabled={_isEmpty(selectedItems)}>Clear all filters</button>
            </div>
            {tagsItems.length > 0 &&
                <div style={{ height: window.innerWidth < 1024 ? calculatedHeight+100  : calculatedHeight-135 }}>
                    <CustomScrollbars style={{ height: 'inherit' }}>
                    <h3 className='app-text-color font-weight-700 gx-mb-0'>Tags</h3>
                    {_map(_groupBy(tagsItems, 'category_label'), (tagsArr, category) => {
                        return <>
                            <h4 className="gx-mt-3 font-weight-700">{category}</h4>
                            <hr className="gx-mt-3" style={{borderColor:'#ebebeb',marginBottom:'-1px'}}/>
                            {tagsArr.map((tag, index) => {
                                return <div key={index} className="gx-d-flex gx-align-items-center gx-my-1" style={{height:'35px'}}>
                                    <input type="checkbox" className='gx-pointer gx-mb-2 gx-mr-3 gx-pb-2' value={tag.id} onChange={(evt) => handleCheckBox('tags', evt.target.value)}
                                        checked={
                                            selectedItems['tags'] && selectedItems['tags'].includes(`${tag.id}`) ? true : false
                                        } />
                                    <h4 className="exhibitor-list-text gx-pointer gx-align-items-center" onClick={() => handleCheckBox('tags', `${tag.id}`)} style={{display:'flex',justifyContent:'space-between',width:'100%'}}>
                                        <span>{tag.label}</span><span className="gx-ml-3 gx-pr-3">{tag.count}</span>
                                    </h4>
                                </div>
                            })}
                        </>
                    })}
                    </CustomScrollbars>
                </div>
            }
        </div>
    )
}

const mapStateToProps = ({ exhibFloor }) => {
    return {
        filterSelectedItems: exhibFloor.selectedItems,
        tagCategories: exhibFloor.tagCategories
    }
}

export default connect(mapStateToProps, { setFIlterSelectedItems })(Search);